import { render, staticRenderFns } from "./StudentInformationHistory.vue?vue&type=template&id=6c51ac25&scoped=true&lang=pug&"
import script from "./StudentInformationHistory.vue?vue&type=script&lang=ts&"
export * from "./StudentInformationHistory.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInformationHistory.vue?vue&type=style&index=0&id=6c51ac25&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51ac25",
  null
  
)

export default component.exports